import React from 'react';

import { PreviewHeader } from 'src/components/atoms/PreviewHeader';
import { SerializableBlock } from '../../../types/Block';
import { ContentPageProps } from '../../../types/PageProps';
import { ContentBlocks } from '../../atoms/ContentBlocks';
import { HiddenPageTitle } from '../../atoms/HiddenPageTitle';
import { Seo } from '../../atoms/Seo';
import * as styles from './RibbonsPage.styles';

const blockHasPageTitle = (blocks: SerializableBlock[]) =>
  blocks.some((block) => block.props.headingIsPageTitle);

export const RibbonsPage = ({
  pageMetadata: { isPreview },
  pageContent: { title, seo, blocks },
}: ContentPageProps) => {
  const renderHiddenPageTitle = !blockHasPageTitle(blocks);

  return (
    <div css={styles.container}>
      <Seo {...seo} />
      {renderHiddenPageTitle && <HiddenPageTitle>{title}</HiddenPageTitle>}
      {isPreview && <PreviewHeader />}
      {blocks ? <ContentBlocks blocks={blocks} isPreview={isPreview} /> : null}
    </div>
  );
};
